import {
  ShippingCode,
  ShippingRange,
} from 'typescript/types/api/shipping_rates';
import t from 'typescript/utilities/translate';
import { OrderSummaryShippingEstimate } from 'typescript/types/api/solidshop';

/**
 * Formats a number to an estimated shipping string
 * ex: 3-5 business days
 * @param range - Shipping estimate range object that comes back from our backend
 * @returns string - formatted string for the shipping estimate
 */
export const getShippingEstimateString = (
  range: ShippingRange | OrderSummaryShippingEstimate,
): string => {
  const { min, max, unit } = range;

  if (!min) {
    return t('productPage.shippingEstimateSingle', {
      max,
      timeUnit: t(`shipping.shippingEstimate.timeUnits.${unit}.one`),
    });
  }

  return t('productPage.shippingEstimate', {
    min,
    max,
    timeUnit: t(`shipping.shippingEstimate.timeUnits.${unit}.other`),
  });
};

/**
 * Formats a number to an estimated shipping string including verb
 * ex: Arrives in 3-5 business days
 * @param range - Shipping estimate range object that comes back from our backend
 * @returns string - formatted string for the shipping estimate
 */
export const getShippingEstimateStringWithVerb = (
  range: ShippingRange | OrderSummaryShippingEstimate,
): string => {
  const { min, max, verb, unit } = range;

  if (!min) {
    return t(`checkout.delivery.shipping.shipSpeed.${verb}.single`, {
      max,
      timeUnit: t(`shipping.shippingEstimate.timeUnits.${unit}.one`),
    });
  }

  return t(`checkout.delivery.shipping.shipSpeed.${verb}.multiple`, {
    min,
    max,
    timeUnit: t(`shipping.shippingEstimate.timeUnits.${unit}.other`),
  });
};

/**
 * @param shippingCode - Shipping code string
 * @returns - Shipping title string
 */
export const getShippingTitleString = (shippingCode: ShippingCode): string => {
  switch (shippingCode) {
    case 'standard': {
      return t('checkout.delivery.shipping.standard');
    }
    case 'two_day': {
      return t('checkout.delivery.shipping.express');
    }
    case 'overnight': {
      return t('checkout.delivery.shipping.rush');
    }
    default: {
      return shippingCode;
    }
  }
};
